module.exports = __webpack_public_path__ + "static/media/ubereats.0923eae9.png";